import axiosClient from "../api/axiosClient";
import { IMEI, DEVICE_TYPE, FIREBASE_TOKEN, DEVICE_LANGUAGE } from "../utils/constants";

// Stable browser device ID — persists across sessions
const getDeviceId = () => {
  const KEY = "ps_device_id";
  let id = localStorage.getItem(KEY);
  if (!id) {
    id = crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(KEY, id);
  }
  return id;
};

export const login = (email, password, rememberMe = true) => {
  const deviceId = getDeviceId();
  const trusted = JSON.parse(localStorage.getItem("ps_trusted_devices") || "[]");
  return axiosClient.post("/Account/Login", {
    email,
    password,
    rememberMe,
    imei: IMEI,
    DeviceType: DEVICE_TYPE,
    FirebaseToken: FIREBASE_TOKEN,
    DeviceLanguage: DEVICE_LANGUAGE,
    DeviceId: deviceId,
    IsTrustedDevice: trusted.length > 0,
  });
};

export const verifyWebLoginOtp = (userId, otp, trustDevice = false) => {
  return axiosClient.post("/PromoterPanel/VerifyWebLoginOtp", {
    UserId: userId,
    Otp: otp,
    TrustDevice: trustDevice,
    DeviceId: getDeviceId(),
  });
};

export const sendWebLoginEmailOtp = (userId) => {
  return axiosClient.post("/PromoterPanel/SendWebLoginEmailOtp", {
    UserId: userId,
    IsFromWebLogin: true,
  });
};

// --- Forgot password (ported from mobile's ForgotPassword/OTPVerification/ResetPassword screens) ---

/** Step 1: request a reset OTP by email. Response's Result field is the userId used by the next two calls. */
export const forgetPassword = (email) =>
  axiosClient.post("/Account/ForgetPassword", { email });

/** Step 2: verify the OTP. otp/userId are path segments, matching mobile exactly — no request body. */
export const verifyForgotPasswordOtp = (otp, userId) =>
  axiosClient.post(`/Account/VerifyOTP/${otp}/${userId}`, null);

/**
 * Resend, reusing the same (misleadingly-named) endpoint mobile uses for email
 * OTP resends. `SendTo` is required by the backend to route Email vs Phone -
 * without it, DeviceApprovalService.SendPhoneOtpAsync defaults to "Phone" and
 * then rejects the request outright since PhoneNumber is null here. Mobile's
 * own SendPhoneOtp action has this same gap (never sends SendTo either), so
 * this was a live bug there too, not something the port introduced.
 */
export const resendForgotPasswordOtp = (email) =>
  axiosClient.post("/Account/SendPhoneOtp", { Email: email, PhoneNumber: null, SendTo: "Email" });

/** Step 3: set the new password. Field names are camelCase here, unlike most other DTOs — matches mobile exactly. */
export const resetPassword = (userId, newPassword, confirmPassword) =>
  axiosClient.post(`/Account/ResetPassword/${userId}`, { newPassword, confirmPassword });
